const styles = (theme) => ({
  mapContainer: { marginLeft: 1, display: "flex", flexDirection: "column" },
  infoContainer: {
    width: "99%",
    marginBottom: "1%",
    border: `1px solid ${theme.AppBGColor}`,
    padding: "2%",
  },
  headerRow: {
    border: `1px solid ${theme.AppBGColor}`,
    padding: "10px",
    borderRadius: "4px 4px 0 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
  },
  headerStyle: {
    fontStyle: "normal",
    fontSize: theme.headerTextFontSize,
    lineHeight: "16px",
    color: theme.HeaderSelectedText,
  },
  headerLabel: {
    color: theme.HeaderSelectedText,
    fontSize: "12px",
    fontWeight: 600,
    paddingBottom: "5px",
  },
  container: { height: "92%", flexFlow: "nowrap" },
  topGridContainer: {
    display: "flex",
    flexDirection: "column"
  },
  bottomGridContainer: { display: "flex", width: "99%", flexDirection: "column", height: "100%" },
  dataGrid: {
    border: `1px solid ${theme.AppBGColor}`,
    height : "100%",
    [`&>.gridTheme-${theme.themeName}>.ag-theme-material.theme-${theme.themeName}`]: {
      height: "100%",
    },
    "& .statusBar": {
      display: "none",
    },
    "& .headerCellStyle": {
      padding: "0px 10px !important",
    },
    "& .ag-theme-material .ag-header-select-all": {
      marginRight: "0px",
    },
    "& .ag-theme-material .ag-cell": {
      lineHeight: "20px",
    },
    "& .ag-theme-material": {
      "& .ag-row.ag-row-selected": {
        backgroundColor: "transparent"
      },
      "& .ag-row.ag-row-selected:hover": {
        backgroundColor: "transparent"
      },
      "& .ag-row.ag-row-selected::after": {
        display: "none"
      },
      "& .ag-row.ag-row-selected::before": {
        display: "none"
      },
    },
    "& .ag-theme-material .ag-icon-checkbox-checked": {
      color: theme.HeaderSelectedText,
    },
    "& .ag-center-cols-viewport": {
      overflowX: "hidden",
    },
    "& .pickupNameCellClass": {
      padding: "0px 10px !important",
    },
    "& .shipperName": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      width: "100%",
      whiteSpace: "nowrap",
    },
    "& .gridCell-alignCenter": {
      alignItems: "center",
      display: "flex",
    },
  },
  checkBoxLabel: {
    color: theme.gridTextColor,
    fontSize: "12px",
    lineHeight: "10px",
    marginBottom: "0px",
    marginTop: "5px",
  },
  checkBoxLabelBold: {
    color: theme.gridTextColor,
    fontSize: "12px",
    lineHeight: "10px",
    fontWeight: 600,
    marginBottom: "5px",
    marginTop: "0px",
  },
  checkBoxStyle: {
    color: theme.gridIconBorderColor,
    "&$checked": {
      color: theme.HeaderSelectedText,
    },
  },
  checkboxGrid: {
    height: "24px",
  },
});

export default styles;
